// Olaf - Ragnarök: Goes berserk for 5 seconds — becomes CC-immune, gains +30% AD,
// +50% attack speed, and +18% bonus lifesteal. Clears existing CC on cast.

import type { Ability, AbilityContext, AbilityHit } from "./Ability";

const ULT_DURATION = 3;

export const olafRagnarok: Ability = {
  id: "olafRagnarok",
  displayName: "Ragnarök",
  description: "Goes berserk for 5 seconds: CC-immune, +30% AD, +50% attack speed, +18% lifesteal. Clears existing CC.",
  iconId: "OlafRagnarok",

  targetShape({ caster }: AbilityContext) {
    return [caster.pos];
  },

  computeHits({ caster }: AbilityContext): AbilityHit[] {
    return [{
      target: caster,
      amount: 0,
      type: "none",
      effect: { kind: "olafUlt", duration: ULT_DURATION },
    }];
  },
};
